import { render, staticRenderFns } from "./MetricasCampanhaOficialPage.vue?vue&type=template&id=7033e862&scoped=true"
import script from "./MetricasCampanhaOficialPage.vue?vue&type=script&lang=js"
export * from "./MetricasCampanhaOficialPage.vue?vue&type=script&lang=js"
import style0 from "./MetricasCampanhaOficialPage.vue?vue&type=style&index=0&id=7033e862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7033e862",
  null
  
)

export default component.exports